/* istanbul ignore file */
export enum WidgetType {
    Pie = 'pie',
    Donut = 'donut',
    Number = 'number',
    Report = 'report',
    Map = 'map',
    ProjectNote = 'projectNote',
}
